import { BaseIcon, BaseIconProps } from './BaseIcon';

export const MonitorPlayGradient: React.FC<BaseIconProps> = (props) => (
  <BaseIcon gradientId="monitorPlayGrad" {...props}>
    <rect width="20" height="14" x="2" y="3" rx="2" stroke="url(#monitorPlayGrad)" />
    <path d="m10 7 5 3-5 3V7ZM8 21h8" stroke="url(#monitorPlayGrad)" />
  </BaseIcon>
);
